import https,  { getApiConfig } from '../../utils/request'
import { RequestParams,ContentType, Method } from 'axios-mapper'

//首页统计订单数据
export const getOrderStatistics = () => {
  const api_config = getApiConfig()
  return https(api_config.migrateUrl).request(`/apistore/v1/${api_config.siteCode}/seller/count`, Method.GET, )
}

//首页聊天数据统计
export const getMessage = () => {
  const api_config = getApiConfig()
  return https('https://chat.kilimall.com/').request(`chat/getNotReadMessageCount`, Method.GET, )
}

//首页文章
export const getArticle = (data: RequestParams) => {
  const api_config = getApiConfig()
  return https(api_config.migrateUrl).request(`/apistore/v1/${api_config.siteCode}/seller/article`, Method.GET, data,ContentType.form )
}

//首页7日数据
export const getStatistical = (data?: RequestParams) => {
  const api_config = getApiConfig()
  return https(api_config.migrateUrl).request(`/apistore/v1/${api_config.siteCode}/seller/statistical`, Method.GET, data,ContentType.form )
}

//首页活动列表
export const getActivityList = (data?: RequestParams) => {
  const api_config = getApiConfig()
  return https(api_config.migrateUrl).request(`/apistore/v1/${api_config.siteCode}/seller/activity`, Method.GET, data,ContentType.form )
}


export const storeSetting = () => {
  const api_config = getApiConfig()
  return https(api_config.migrateUrl).request(`/apistore/v1/${api_config.siteCode}/seller/store/setting`, Method.GET)
}